export default "__VITE_ASSET__BVcgkGuC__"